
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/assessment/me",
      function () {
        return require("private-next-pages/assessment/me/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/assessment/me"])
      });
    }
  